<template>
  <TitleWrapper
    title="SYLLABUS_AUTOMATOR"
    additional-name="Settings"
    :is-buttons-hidden="true"
    :is-right-bar-button-hidden="true"
  />
  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <NoRecordFound />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <SyllabusAutomatorPermission />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <SyllabusAutomatorNotification />
  </div>
</template>

<script>
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
import SyllabusAutomatorNotification from '@src/router/views/settings/notifications/syllabus-manager/syllabus-template/SyllabusTemplateNotificationView.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import SyllabusAutomatorPermission from '@src/router/views/settings/system-settings/SyllabusTemplatePermission.vue'
import UITabs from '@src/components/UiElements/UITabs.vue'
import TitleWrapper from '@components/TitleWrapper.vue'

export default {
  name: 'Settings',
  components: {
    UITabs,
    TitleWrapper,
    NoRecordFound,
    SyllabusAutomatorNotification,
    SyllabusAutomatorPermission,
  },

  page: {
    title: 'Features Settings',
  },

  data() {
    return {
      FEATURES_TABS,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },
}
</script>
